import {LightBoxProps} from './types'
import LightBoxView from './LightBoxView'
import React from 'react'

const LightBox = (props: LightBoxProps): React.ReactElement | null => <LightBoxView {...props} />
export default LightBox
